<script setup lang="ts">
import LanguagesRepository from '@repositories/languages.repository';
import i18n from '../helpers/lang/i18n';
import { loadLocaleMessages } from '../helpers/lang/loadLocale';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import useAuthStore from '@store/auth';

const { user } = useAuthStore();
const showOptions = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);
const optionsLanguages = ref<any>(null);
const currentLanguage = ref<string>('');

// Función para cambiar idioma
const handleLanguage = async (lang: string = 'es_ar', language: string) => {
  const messages = loadLocaleMessages(lang);
  i18n.global.setLocaleMessage(lang, messages);
  i18n.global.locale.value = lang;


  const selected = optionsLanguages.value?.find((l: any) => l.language === language);
  if (selected) {
    currentLanguage.value = selected.language;
  }

  showOptions.value = false;
};

// Función para detectar click fuera del dropdown
const handleClickOutside = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    showOptions.value = false;
  }
};

onMounted(async() => {
  document.addEventListener('click', handleClickOutside);
  const { data } = await LanguagesRepository.getlanguages();
  optionsLanguages.value = data.languages;
  if(!user)	return;
  const selected = data.languages.find((l: any) => l.language === user.language.language);
  if (selected) {
    currentLanguage.value = selected.language;
  }
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<template>
	<div class="container_header">
	  <div class="container_select_language" ref="dropdownRef">
		<button class="btn_language" @click="showOptions = !showOptions">
		  <img class="planet_img" src="/icons/language.svg" alt="language" />
		</button>
		<div class="dropdown_options" v-if="showOptions">
		  <button
			v-for="lang in optionsLanguages"
			:key="lang.id"
			class="dropdown_item"
			:class="{ active: currentLanguage === lang.language }"
			@click="handleLanguage(lang.fileJson, lang.language)"
		  >
			{{ lang.language }}
		  </button>
		</div>
	  </div>
	</div>
  </template>

<style scoped>
.container_header {
  position: fixed;
  top: 15px;
  right: 10px;
  z-index: 999;
  margin: 0px 34px 0px;
}

.container_select_language {
  position: relative;
}

.btn_language {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.planet_img {
  width: 33px;
  margin-left: 6px;
}

.dropdown_options {
  position: absolute;
  top: 40px;
  right: 0;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  animation: fadeIn 0.3s ease;
  min-width: 200px;
  z-index: 999;
 
}

.dropdown_item {
  width: 100%;
  padding: 10px 15px;
  text-align: left;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: background 0.2s ease;
  text-align: center;
}

.dropdown_item:hover {
  background-color: #f0f0f0;
}

.dropdown_item.active {
  color: #ff436f;
  font-weight: bold;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
